import { render, staticRenderFns } from "./ProductAndPrices.vue?vue&type=template&id=6ed49dde"
import script from "./ProductAndPrices.vue?vue&type=script&lang=js"
export * from "./ProductAndPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports